import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../util/Constants';
import DateUtil from '../util/Util';

class LeadController {

  static Staff = 'responsible_person';

  static addModel = fields => {
    const user = reactLocalStorage.getObject(Const.LoggedInUser).user_id;

    let lead ={};
    const keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(!fields[keys[i]].editable) continue;
      //TODO: special 
      const fieldType = fields[keys[i]].field_type;
      const val = fields[keys[i]].default_value;
      if(fieldType === Const.Date || fieldType === Const.DateTime) {
        lead[keys[i]] = '';
        if(val === 'today') lead[keys[i]] = DateUtil.dateToServerDateTime(new Date());
      } else if(fieldType === Const.Address) {
        lead[keys[i]] = [];
      } else if(keys[i] === LeadController.Staff) {
        lead[keys[i]] = '~' + user + '~';
      } else if(fieldType.includes(Const.MultiSelect)) {
        lead[keys[i]] = '';
        if(val !== '') lead[keys[i]] = '~' + val.replace(',', '~') + '~';
      } else {
        lead[keys[i]] = val;
      }
    }
    lead.status = Const.Active;
    return lead;
  }

  static getCustomFields = fields => {
    let customField = {};
    let keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(keys[i] !== 'id' && keys[i] !== 'status'
        && keys[i] !== 'direction' && keys[i] !== 'date_time' && keys[i] !== 'responsible_person'
        && keys[i] !== 'feedback' && keys[i] !== 'comment' 
        && keys[i] !== 'next_call' && keys[i] !== 'next_meet'
        && keys[i] !== 'created_by' && keys[i] !== 'updated_by'
        && keys[i] !== 'created_date' && keys[i] !== 'updated_date'
        && fields[keys[i]].status !== Const.Trash) {
        customField[keys[i]] = fields[keys[i]];
      }
    }
    return customField;
  }
}
export default LeadController;